module.exports = __webpack_public_path__ + "img/home6.733b3e86.png";